import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from "formik";
import Button from "@mui/material/Button";
import * as yup from "yup";
import { useNavigate } from 'react-router-dom';
import { alpha, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { toast } from 'react-toastify';
import Box from '@mui/material/Box';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import AppBar from '@mui/material/AppBar';
import Container from "../../GeneralComponents/Container";
import { Topbar, Sidebar } from '../components';
import setGlobalLoader from '../../../redux/actions/loaderActions'
import { createAdmin } from '../../../redux/actions/apiActions'
import { CircularProgress } from '@mui/material';

const validationSchema = yup.object({
    name: yup
        .string()
        .trim()
        .required("Name is required."),
    phoneNumber: yup
        .string()
        .trim()
        .required("Phone Number is required.")
        .min(10, "Phone number short than 10 digits.")
        .max(10, "Phone number long than 10 digits."),
    email: yup
        .string()
        .trim()
        .email("Invalid email.")
        .optional()
        .nullable()
})

const AddAdmin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const role = useSelector(state => state.authReducer.role);
    const loaderStatus = useSelector(state => state.loaderStatus);

    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [openSidebar, setOpenSidebar] = useState(false);

    const handleSidebarOpen = () => {
        setOpenSidebar(true);
    };

    const handleSidebarClose = () => {
        setOpenSidebar(false);
    };
    const open = isMd ? false : openSidebar;

    const handleOnSubmit = async (values) => {

        const confirmation_pin = window.prompt("Confirmation Password")
        dispatch(setGlobalLoader(true))

        try {
            await createAdmin({ ...values, pin: confirmation_pin });
            toast.success("Admin added successfully");
            navigate("/admins")
            dispatch(setGlobalLoader(false))
        } catch (error) {
            dispatch(setGlobalLoader(false))
            console.log("create admin error", error);
            toast.error(error.response.data.message ?? "some error occured while creating admin");
        }
    }

    return (
        <Box>
            <AppBar
                position={'fixed'}
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                }}
                elevation={0}
            >
                <Container maxWidth={1} paddingY={{ xs: 1, sm: 1.5 }}>
                    <Topbar onSidebarOpen={handleSidebarOpen} />
                </Container>
            </AppBar>
            <Sidebar
                onClose={handleSidebarClose}
                open={open}
                variant={isMd ? 'permanent' : 'temporary'}
            />
            <main>
                <Box height={{ xs: 94, sm: 102, md: 107 }} />
                <br />
                <br />

                <Box
                    overflow="hidden"
                    marginLeft={{ md: '270px' }}
                >
                    <Typography
                        variant={"subtitle2"}
                        sx={{ marginBottom: 2 }}
                        fontWeight={700}
                    >
                        Add Admin
                    </Typography>

                    <Formik
                        initialValues={{
                            name: '',
                            phoneNumber: '',
                            email: '',
                        }}

                        validationSchema={validationSchema}
                        onSubmit={(values) => handleOnSubmit(values)}
                        enableReinitialize
                    >
                        {(formikProps) => {
                            const { values, errors, touched, setFieldValue, handleSubmit, isSubmitting } =
                                formikProps;
                            return (
                                <form onSubmit={handleSubmit}>
                                    <Grid container spacing={{ xs: 2, md: 4 }} sx={{ padding: '10px' }}>

                                        <Grid item xs={12} sm={6} md={7}>
                                            <Typography
                                                variant={"subtitle2"}
                                                sx={{ marginBottom: 2 }}
                                                fontWeight={700}
                                            >
                                                Enter Name
                                            </Typography>
                                            <TextField
                                                label="Name *"
                                                variant="outlined"
                                                name={"name"}
                                                fullWidth
                                                value={values.name}
                                                onChange={(e) =>
                                                    setFieldValue("name", e.target.value)
                                                }
                                                error={
                                                    touched.name && Boolean(errors.name)
                                                }
                                                helperText={touched.name && errors.name}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={7}>
                                            <Typography
                                                variant={"subtitle2"}
                                                sx={{ marginBottom: 2 }}
                                                fontWeight={700}
                                            >
                                                Phone Number
                                            </Typography>
                                            <TextField
                                                label="Phone Number *"
                                                variant="outlined"
                                                name={"phoneNumber"}
                                                fullWidth
                                                type="number"
                                                value={values.phoneNumber}
                                                onChange={(e) =>
                                                    e.target.value.toString().length > 10 ?
                                                        setFieldValue("phoneNumber", e.target.value.substring(0, 10))
                                                        :
                                                        setFieldValue("phoneNumber", e.target.value)
                                                }
                                                error={
                                                    touched.phoneNumber && Boolean(errors.phoneNumber)
                                                }
                                                helperText={touched.phoneNumber && errors.phoneNumber}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={7}>
                                            <Typography
                                                variant={"subtitle2"}
                                                sx={{ marginBottom: 2 }}
                                                fontWeight={700}
                                            >
                                                Enter Email
                                            </Typography>
                                            <TextField
                                                label="Email"
                                                variant="outlined"
                                                name={"email"}
                                                fullWidth
                                                value={values.email}
                                                onChange={(e) =>
                                                    setFieldValue("email", e.target.value)
                                                }
                                                helperText={touched.email && errors.email}
                                            />
                                        </Grid>
                                        <br />
                                        <br />

                                    </Grid>
                                    <br />
                                    <Button
                                        component={'button'}
                                        variant={"contained"}
                                        fontWeight={700}
                                        type='submit'
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? <CircularProgress /> : 'Submit'}
                                    </Button>

                                </form>
                            )
                        }}
                    </Formik>
                </Box>
            </main>
        </Box>
    );
};

export default AddAdmin;
